import React from 'react'
import { Pie } from '@ant-design/charts'
import { Card } from 'antd'

interface BreakdownItem {
  label: string
  count: number
}

interface Props {
  data: BreakdownItem[]
}

const ByFormalityType = ({ data }: Props) => {
  const config = {
    data: data.map(d => ({ type: d.label, value: d.count })),
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    label: {
      text: (d: { type: string; value: number }) => `${d.type}\n${d.value}`,
      style: { fontSize: 11 },
    },
  }

  return (
    <Card title="Répartition par type de formalité" style={{ borderRadius: 8 }}>
      <Pie {...config} height={280} />
    </Card>
  )
}

export default ByFormalityType
